// extracted by mini-css-extract-plugin
export default {"list":"ValuesSearch_list__a5F6h","wrapper":"ValuesSearch_wrapper__6Rm+1"};